import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Gauge } from "lucide-react";

export default function UsageMeter() {
  const [data, setData] = useState(null);

  const load = () => api.get("/assistant/limits").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const t = setInterval(load, 30_000);
    return () => clearInterval(t);
  }, []);

  if (!data) return null;
  const rows = [
    { label: "AI Chats", used: data.used.chat, cap: data.caps.chat, unit: "" },
    { label: "Read aloud", used: data.used.tts, cap: data.caps.tts, unit: "" },
    { label: "Voice minutes", used: Math.round(data.used.voice_seconds / 60), cap: Math.round(data.caps.voice_seconds / 60), unit: "min" },
  ];

  return (
    <div className="card-elevated p-4" data-testid="usage-meter">
      <div className="flex items-center gap-2 text-xs uppercase tracking-widest text-muted-foreground font-semibold">
        <Gauge className="w-3.5 h-3.5" /> Daily usage · {data.tier === "premium" ? "Full Access" : "Standard"}
      </div>
      <div className="mt-3 grid sm:grid-cols-3 gap-3">
        {rows.map((r) => {
          const pct = Math.min(100, Math.round((r.used / Math.max(1, r.cap)) * 100));
          const danger = pct >= 90;
          return (
            <div key={r.label} data-testid={`usage-${r.label.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="flex items-baseline justify-between text-xs">
                <span className="font-semibold">{r.label}</span>
                <span className={danger ? "text-destructive" : "text-muted-foreground"}>
                  {r.used}{r.unit && ` ${r.unit}`} / {r.cap}{r.unit && ` ${r.unit}`}
                </span>
              </div>
              <div className="mt-1.5 h-1.5 rounded-full bg-muted overflow-hidden">
                <div className={["h-full transition-all", danger ? "bg-destructive" : "bg-primary"].join(" ")}
                  style={{ width: `${pct}%` }} />
              </div>
            </div>
          );
        })}
      </div>
      <p className="mt-3 text-[11px] text-muted-foreground">Resets at midnight UTC.</p>
    </div>
  );
}
